export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20casual%20style%20warm%20indoor%20lighting%20natural%20expression%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-c1&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这个瓜也太大了！我追了三天三夜，物料越扒越多，感觉后面还有反转。坐等明天的新料。',
    likes: 2834,
    tag: '热评',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20trendy%20style%20warm%20indoor%20lighting%20natural%20expression%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-c2&orientation=squarish',
    name: '娱乐圈观察员',
    time: '18分钟前',
    content: '作为圈内边缘人士说一句，这波操作绝对不是偶然。之前某颁奖礼上那个眼神交流已经说明一切了。',
    likes: 1956,
    tag: '热评',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20elegant%20style%20warm%20indoor%20lighting%20natural%20smile%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-c3&orientation=squarish',
    name: '追剧小达人',
    time: '42分钟前',
    content: '爆瓜网的信息更新速度真的快！比微博热搜还早两小时就出详细分析了，以后就蹲这儿吃瓜了。',
    likes: 1567,
    tag: '',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20man%20portrait%20casual%20style%20warm%20indoor%20lighting%20friendly%20expression%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-c4&orientation=squarish',
    name: '老戏骨影迷',
    time: '1小时前',
    content: '不喜欢看这些八卦，但爆瓜网的影视深度分析还是值得一看的。上次那篇关于新锐导演的专题做得不错。',
    likes: 892,
    tag: '',
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20fashionable%20style%20warm%20indoor%20lighting%20playful%20expression%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-c5&orientation=squarish',
    name: '深夜瓜田守望者',
    time: '2小时前',
    content: '凌晨三点还有新料放出来，这个运营团队是不睡觉的吗？respect！已经安利给整个办公室的姐妹们了。',
    likes: 2134,
    tag: '热评',
  },
];